import { Box } from "@mui/material";
import { type FC, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	type SortKey,
	SortTypes,
} from "web_myplann/Portfolio/Components/SortDrawer";
import { PortfolioListPage } from "web_myplann/Portfolio/Pages/PortfolioListPage";
import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const StandalonePortfolioListLegacy: FC = () => {
	const { t } = useResource();
	const [activeSort] = useState<SortKey>(SortTypes.default);
	const [isLoading, setIsLoading] = useState(true);

	return (
		<MyPlannLayout
			disableContentPadding
			disableBottomPadding
			topBar={
				<NavigationHeader title={t(Resources.Portfolio.Titles.portfolio)} />
			}
		>
			{isLoading && (
				<StyledCenteredStack spacing={2} px={5} zIndex={10}>
					<RowSkeletonLoader />
					<RowSkeletonLoader />
					<RowSkeletonLoader />
				</StyledCenteredStack>
			)}
			<Box
				sx={{
					opacity: isLoading ? 0 : 1,
					transition: "opacity 0.2s",
					pt: "0 !important",
				}}
			>
				<PortfolioListPage
					activeSort={activeSort}
					setIsLoading={setIsLoading}
				/>
			</Box>
		</MyPlannLayout>
	);
};
